import { Breadcrumb, TitleScreen } from "components/Core"
import FormRoute from "components/Custom/FormRoute"

const NewScreen = () => {
  return (
    <div className="w-full h-full flex flex-col items-start justify-start pb-10">
      <Breadcrumb
        data={[
          { name: "Listado de rutas", href: "/routes" },
          { name: "Creación de ruta", href: "/routes/new" },
        ]}
      />
      <div className="w-full flex flex-col justify-center items-center pt-4 px-6">
        <TitleScreen title="creación de ruta" />
      </div>
      <div className="w-full flex flex-col py-2 px-4">
        <FormRoute />
      </div>
    </div>
  )
}

export default NewScreen
